// SPDX-FileCopyrightText: Copyright 2024 Dash0 Inc.
// @ts-nocheck

"use client";

import { ReactNode, Children } from "react";

import { ButtonLink } from "@/components/ui/button";

type CtaButtonProps = {
  href: string;
  external?: boolean;
  children: ReactNode;
};

export function CtaButton({ href, external, children }: CtaButtonProps) {
  let element = children instanceof Array ? children[0] : children;
  const looksLikeParagraph =
    element &&
    typeof element === "object" &&
    "type" in element &&
    element.type === "p";

  if (looksLikeParagraph) {
    element =
      element.props.children instanceof Array
        ? element.props.children[0]
        : element.props.children;
  }

  return (
    <ButtonLink
      variant="cta-brand"
      href={href}
      external={external}
      size="sm"
      className="no-underline mb-4 text-white"
    >
      {element}
    </ButtonLink>
  );
}
